
const NewYorkShowcase: React.FC = () => {
  const handleGetQuote = () => {
    const event = new CustomEvent('openContactModal', { 
      detail: { type: 'nyc-quote' } 
    });
    window.dispatchEvent(event);
  };

  const handleViewPortfolio = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/elite-portfolio');
    }
  };

  return (
    <section className="relative py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20"></div>
      <div className="absolute top-10 sm:top-20 right-10 sm:right-20 w-20 h-20 sm:w-32 sm:h-32 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full opacity-20 animate-pulse"></div>
      <div className="absolute bottom-10 sm:bottom-20 left-10 sm:left-20 w-32 h-32 sm:w-48 sm:h-48 bg-gradient-to-br from-pink-400 to-red-500 rounded-full opacity-15 animate-bounce" style={{ animationDuration: '4s' }}></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="text-white space-y-6 sm:space-y-8 order-2 lg:order-1">
            <div className="space-y-4 sm:space-y-6">
              <div className="inline-block px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm font-semibold text-sm sm:text-base tracking-wider mb-2">
                TIMES SQUARE SHOWCASE
              </div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight">
                Iconic New York City Billboard Campaigns
              </h2>
              <h3 className="text-lg sm:text-xl lg:text-2xl text-blue-200 font-medium">
                Times Square & Manhattan Premium Locations
              </h3>
            </div>
            
            <p className="text-base sm:text-lg lg:text-xl text-gray-200 leading-relaxed">
              Dominate the world's most famous advertising landscape with premium billboard placements in Times Square, Broadway corridors, and Manhattan's high-traffic districts. Our NYC campaigns deliver unmatched global visibility and brand prestige.
            </p>

            {/* Stats Grid - Mobile Optimized */}
            <div className="grid grid-cols-2 gap-4 sm:gap-6 py-4 sm:py-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20 text-center">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-yellow-400 mb-2">50M+</div>
                <div className="text-sm sm:text-base text-gray-300">Annual Visitors</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 border border-white/20 text-center">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-blue-400 mb-2">24/7</div>
                <div className="text-sm sm:text-base text-gray-300">Global Exposure</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
              <button 
                onClick={handleGetQuote}
                className="bg-gradient-to-r from-yellow-500 to-orange-600 text-black px-8 py-4 sm:py-5 rounded-xl font-bold hover:shadow-2xl transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer text-base sm:text-lg"
              >
                Get NYC Quote
              </button>
              <button 
                onClick={handleViewPortfolio}
                className="border-2 border-white text-white px-8 py-4 sm:py-5 rounded-xl hover:bg-white hover:text-gray-900 transition-colors font-medium text-base sm:text-lg whitespace-nowrap cursor-pointer"
              >
                View NYC Portfolio
              </button>
            </div>

            {/* Feature Icons */}
            <div className="flex items-center justify-center sm:justify-start gap-6 sm:gap-8 pt-4 sm:pt-6">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-building-line text-xl sm:text-2xl text-yellow-400"></i>
              </div>
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-camera-line text-xl sm:text-2xl text-blue-400"></i>
              </div>
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-global-line text-xl sm:text-2xl text-purple-400"></i>
              </div>
            </div>
          </div>

          {/* Image Section */}
          <div className="relative order-1 lg:order-2">
            <div className="aspect-[4/3] bg-gradient-to-br from-yellow-600/20 to-orange-600/20 rounded-2xl backdrop-blur-sm border border-white/10 overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/2773c5d3917916cb89cb8b2df0c21360.jpg"
                alt="Times Square Billboard Campaign"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            
            {/* Floating Stats - Responsive */}
            <div className="absolute -bottom-3 sm:-bottom-6 -left-3 sm:-left-6 bg-white/10 backdrop-blur-md rounded-xl p-3 sm:p-4 border border-white/20">
              <div className="text-lg sm:text-2xl font-bold text-yellow-400">Times Square</div>
              <div className="text-xs sm:text-sm text-gray-300">Premium Location</div>
            </div>
            
            <div className="absolute -top-3 sm:-top-6 -right-3 sm:-right-6 bg-white/10 backdrop-blur-md rounded-xl p-3 sm:p-4 border border-white/20">
              <div className="text-lg sm:text-2xl font-bold text-blue-400">Global</div>
              <div className="text-xs sm:text-sm text-gray-300">Brand Visibility</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewYorkShowcase;
